import React from 'react'
import { Icon } from '@manychat/manyui'

import { IconNames } from 'common/core/interfaces/alert'

import cm from './styles.module.css'

interface HintCardProps {
  title: string
  icon: IconNames
  text: string
}

export const HintCard = ({ title, icon, text }: HintCardProps) => {
  const TextIcon = Icon[icon]

  return (
    <section className={cm.hintCard}>
      <h4 className="font-semibold">{title}</h4>

      <div className="m-t-sm d-flex align-center gap-sm">
        <span className={cm.hintCard__iconWrapper}>
          <TextIcon size={16} />
        </span>

        <p className="m-0 text-secondary">{text}</p>
      </div>
    </section>
  )
}
